'use client'
import { submitEmailToList } from '@/lib/mailchimp'
import { useState } from 'react'
import { useToast } from '@/components/ui/use-toast'
import { Toaster } from '@/components/ui/toaster'
import { Button } from 'flowbite-react'

export const NewsletterSignupAndDonate = () => {
  const [email, setEmail] = useState('')
  const { toast } = useToast()

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (!email.includes('@')) return
    await submitEmailToList(email)
      .then((result) => {
        setEmail('')
        toast(result.toast)
      })
      .catch((err) => console.log('err', err))
  }

  return (
    <>
      <div className="z-[9999] fixed w-full top-0 border-none">
        <Toaster />
      </div>
      <div className="hidden md:flex md:flex-col md:gap-[12px]">
        <p className="w-[160px] xl:w-[188px] font-bold leading-normal text-sm xl:leading-normal xl:text-lg">
          Sign up for our weekly newsletter
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-[12px]">
          <input
            id="newsletter-signup-component"
            className="text-black align-middle h-[27px] w-[160px] xl:w-[225px] rounded-md text-sm px-[10px] focus:border-none focus:outline-none placeholder:text-xs placeholder:xl:text-sm shadow-[0px_4px_4px_rgba(0,0,0,0.3)]"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            aria-label="Email Address"
            placeholder="Enter your email"
          />
          <button
            type="submit"
            className="h-[31px] rounded-md bg-black font-bold !text-white text-sm w-[160px] xl:w-[225px] shadow-[0px_4px_4px_rgba(0,0,0,0.3)] focus:border-none focus:outline-none "
          >
            Subscribe
          </button>
        </form>
        <Button
          href="https://buy.stripe.com/28obJ72az6zz5cQ5kv"
          target="_blank"
          className="items-center h-[31px] rounded-md bg-[#FCE96A] font-bold !text-black text-sm justify-center w-[160px] xl:w-[225px] shadow-[0px_4px_4px_rgba(0,0,0,0.3)] !focus:border-none !focus:outline-none focus:ring-0"
        >
          Donate
        </Button>
      </div>
    </>
  )
}

export default NewsletterSignupAndDonate
